import { render } from "./oauth_callback.vue?vue&type=template&id=f514124c"
import script from "./oauth_callback.js?vue&type=script&lang=js"
export * from "./oauth_callback.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__